// Better Auth React client. Components call signIn / signOut /
// useSession through here; cookies travel automatically same-origin.

'use client'

import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  baseURL: typeof window !== 'undefined' ? window.location.origin : undefined,
})

export const { signIn, signOut, signUp, useSession, getSession } = authClient
